import { render, staticRenderFns } from "./CoolingOffChoose.vue?vue&type=template&id=cfb585b0&scoped=true&"
import script from "./CoolingOffChoose.vue?vue&type=script&lang=js&"
export * from "./CoolingOffChoose.vue?vue&type=script&lang=js&"
import style0 from "./CoolingOffChoose.vue?vue&type=style&index=0&id=cfb585b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb585b0",
  null
  
)

export default component.exports